module.exports = __webpack_public_path__ + "img/ppt-2.1159ff56.webp";